var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-link dropdown"},[_c('button',{staticClass:"dropdown-toggle inline-flex font-semibold",attrs:{"data-toggle":"dropdown"}},[_vm._t("default"),(_vm.$slots.content)?_c('icon',{attrs:{"name":"arrow","size":"sm"}}):_vm._e()],2),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }